// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  // MenuItem,
  // Select,
  // FormControl,
  // InputLabel,
  Switch,
  Divider,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
// import MDBadge from "theme/components/MDBadge";
// import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import AppConfig from "appConfig";

function MessagingCampaignView() {
  const pageTitle = "Messaging Campaign View";
  usePageTitle(pageTitle);
  const { id: reference } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [campaign, setCampaign] = useState({});
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [runs, setRuns] = useState([]);

  const [startTime, setStartTime] = useState(null);
  const [openScheduleDialog, setOpenScheduleDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);

  async function scheduleMessage() {
    if (startTime === null || startTime === "") {
      setSeverity("error");
      setErrMsg("A valid schedule date and time is required.");
      setOpen(true);
      return;
    }

    const formattedTime = startTime.replace("T", " ");
    const json = {
      reference: `${reference}`,
      start_time: `${formattedTime}:00`,
    };

    setShowLoading(true);
    setOpenScheduleDialog(false);

    await axios
      .post(`/portal/broadcasts/schedule.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateStatus() {
    setShowLoading(true);
    await axios
      .get(`/portal/broadcasts/${reference}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/broadcasts/${reference}/get.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.broadcast);
            setTotalCustomers(result.data.data.total_customers);
            setRuns(result.data.data.runs);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  const [openUploadCustomersDialog, setOpenUploadCustomersDialog] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/broadcasts/customers/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
        setRefreshPage(!refreshPage);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadCustomers = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("broadcast", reference);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadCustomersDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    setUploadFile(e.target.files[0]);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openUploadCustomersDialog}>
        <DialogTitle>
          <MDBox>Upload Customers</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2} pl={3} alignContents="center">
              <a
                href={`${AppConfig.api_media_url}documents/templates/customer_upload_template.csv`}
                target="_blank"
                rel="noreferrer"
              >
                == Sample Template ==
              </a>
            </MDBox>
            <Divider />
            <MDBox mt={2}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadCustomersDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadCustomers();
            }}
          >
            Upload Customers
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openScheduleDialog}>
        <DialogTitle>
          <MDBox>Schedule Message</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                placeholder="Schedule Time"
                name="start_time"
                margin="dense"
                label="Schedule Time"
                type="datetime-local"
                fullWidth
                variant="outlined"
                onChange={(e) => setStartTime(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenScheduleDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              scheduleMessage();
            }}
          >
            Schedule Message
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <MDBox>
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={6} lg={6} align="center">
                  <MDButton
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      navigate(`/campaigns/${campaign.campaign.reference}/stats`);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>receipt</Icon>
                    &nbsp; View Payments
                  </MDButton>
                </Grid>
                <Grid item xs={6} md={6} lg={6} align="center">
                  <MDButton
                    variant="outlined"
                    color="info"
                    onClick={() => {
                      setUploadFile(null);
                      setOpenUploadCustomersDialog(true);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                    &nbsp;Upload Customers
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <Grid container spacing={3}>
                      <Grid item xs={6} md={6} lg={6}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Messaging Information
                        </MDTypography>
                      </Grid>
                      {/* <Grid item xs={6} md={6} lg={6}>
                        <MDTypography variant="h6" fontWeight="light" align="right">
                          <a
                            href={`${AppConfig.api_base_url}campaigns/reports/${campaign.id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Icon sx={{ fontWeight: "bold" }}>download</Icon> &nbsp;Reports
                          </a>
                        </MDTypography>
                      </Grid> */}
                    </Grid>
                  </MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="campaign information">
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Subject
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {campaign.subject}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Message Body
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              <div dangerouslySetInnerHTML={{ __html: campaign.message_body }} />
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Customer Audience
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {campaign.audience}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Total Reach
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {totalCustomers}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Status
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDBox>
                              {/* <MDBadge
                                badgeContent={campaign.status ? "ACTIVE" : "DISABLED"}
                                variant="contained"
                                container
                                color={campaign.status ? "success" : "error"}
                              /> */}
                              <Switch
                                color={campaign.status ? "success" : "error"}
                                checked={campaign.status}
                                onChange={() => updateStatus()}
                                // inputProps={{ "aria-label": "controlled" }}
                              />
                            </MDBox>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              CTA
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              <a href={campaign.payment_link} target="_blank" rel="noreferrer">
                                <Icon>send</Icon>&nbsp; Payment Link
                              </a>
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Date Added
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {campaign.created}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <Grid container spacing={3}>
                      <Grid item xs={6} md={6} lg={6}>
                        <MDBox>
                          <MDBox display="flex" justifyContent="space-between" alignItems="right">
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              textTransform="capitalize"
                            >
                              Message Schedule
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="campaign information">
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Channels
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            {campaign.channels ? (
                              <MDTypography variant="h6" fontWeight="light">
                                {
                                  // --> Notice below changes
                                  campaign.channels.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    campaign.channels.map((record) => <span>{record} | </span>)
                                }
                              </MDTypography>
                            ) : (
                              <> </>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Frequency
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {campaign.frequency}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Interval
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {campaign.interval}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        {/* <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium">
                              Start Time
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {campaign.start_time}
                            </MDTypography>
                          </TableCell>
                        </TableRow> */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Message Log
                      </MDTypography>
                      <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                        <MDBox>
                          <MDButton
                            variant="outlined"
                            color="warning"
                            iconOnly
                            onClick={() => {
                              setStartTime(null);
                              setOpenScheduleDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>alarm_add</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="message logs">
                      <TableBody>
                        <TableRow>
                          <TableCell align="left">
                            <MDTypography variant="h6" fontWeight="medium">
                              Completed
                            </MDTypography>
                          </TableCell>
                          <TableCell align="center">
                            <MDTypography variant="h6" fontWeight="medium">
                              Scheduled Run
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="medium">
                              Next Run
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        {
                          // --> Notice below changes
                          runs.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            runs.map((record) => (
                              <TableRow>
                                <TableCell align="left">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <MDBox>
                                      <Icon color={record.status ? "warning" : "success"}>
                                        {!record.status ? "check_circle" : "timer"}
                                      </Icon>
                                    </MDBox>
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="center">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {record.trigger_time}
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {record.next_run}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MessagingCampaignView;
